import React from 'react';
import PropTypes from 'prop-types';
import { Space } from 'antd';
import { FormItemLabel, FormItemLabelDescription } from '../Forms';

const InviteLabelForm = ({ label, description }) => (
  <>
    <Space>
      <FormItemLabel>{label}</FormItemLabel>
      <FormItemLabelDescription>{description}</FormItemLabelDescription>
    </Space>
  </>
);

export default InviteLabelForm;

InviteLabelForm.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
